export default __webpack_public_path__ + "static/media/icon-stats.44850db4.svg";